import { render, staticRenderFns } from "./TrusteeToTrusteeTransferCustodian.vue?vue&type=template&id=3ca02ad6"
import script from "./TrusteeToTrusteeTransferCustodian.vue?vue&type=script&lang=ts"
export * from "./TrusteeToTrusteeTransferCustodian.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports